
// REACT
import { RouterProvider } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useAuth0 } from "@auth0/auth0-react";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from "react-toastify";

// CONTEXT
import { maincontext } from "./context/maincontext";

// ASSETS
import languagePack from "./assets/languages/languagePack";

// ROUTES
import { adminRouter, userRouter } from "./routes/routes";

// PAGES
import Login from "./pages/Login";

// COMPONENTS
import RoleRestrictionModal from './components/common/RoleRestrictionModal';

// SERVICES
import modalHandler from './services/modalHandler';

function App() {
  // SETTING THE LANGUAGE
  const [language, setLanguage] = useState(() => {
    const savedLanguage = Cookies.get('language');
    return savedLanguage && languagePack[savedLanguage] ? savedLanguage : "hu";
  });

  // MODAL
  const [modalItem, setModalItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // AUTH0 UTILITIES
  const {
    user, isAuthenticated, isLoading,
    getAccessTokenSilently, getIdTokenClaims, logout,
  } = useAuth0();

  // ADMIN STATE
  const [isAdmin, setIsAdmin] = useState(null)

  // USER STATE
  const [isDistributor, setIsDistributor] = useState(null);

  // TOKEN VAR
  const [token, setToken] = useState(null)

  // GET ACCESS TOKEN
  useEffect(() => {
    const getAccessToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUDIENCE,
            scope: process.env.REACT_APP_SCOPE
          },
        });
        // GET USER EMAIL FROM ID TOKEN
        await getIdTokenClaims();

        const decodedToken = jwtDecode(accessToken);
        setIsAdmin(decodedToken.permissions?.includes("access:admin"));
        setIsDistributor(decodedToken.permissions?.some(p => p.startsWith("distributor:")));

        if (!decodedToken.permissions?.includes("access:admin") &&
          !decodedToken.permissions?.some(p => p.startsWith("distributor:"))) {
          modalHandler(
            <RoleRestrictionModal onConfirm={() => {
              setShowModal(false);
              logout({ logoutParams: { returnTo: window.location.origin } });
            }} />,
            setModalItem,
            true,
            setShowModal
          );
        }

        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
        setToken(null);
      }
    }
    getAccessToken();

    // eslint-disable-next-line
  }, [])


  // RENDER
  return (
    <div className="App">
      <maincontext.Provider value={{
        language, setLanguage,
        isAdmin,
        token,
        user,
        logout
      }}>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {showModal && <>{modalItem}</>}

        {
          isAuthenticated && token && !showModal ? (
            (isAdmin || isDistributor) ? (
              <RouterProvider router={isAdmin ? adminRouter : userRouter} />
            ) :
              null
          ) : (
            <Login isLoading={isLoading} />
          )
        }
      </maincontext.Provider >
    </div>
  );
}

export default App;
